import { h } from 'preact';
import { render } from '@testing-library/preact';
import userEvent from '@testing-library/user-event';
import { expect } from 'chai';
import { Avatar } from './Avatar';

describe('Test Avatar component', () => {
  it('render', async function () {
    const content = render(<Avatar>TN</Avatar>);
    const initials = await content.findByText('TN');
    expect(initials).not.null;
    userEvent.click(initials);
  });

  it('applies Linaria CSS classes', async () => {
    const content = render(<Avatar />);
    const firstElement = content.container.firstElementChild;
    // @ts-ignore
    const classList = firstElement.classList;
    expect(classList.length).equals(3);
    expect(Array.from(classList).some((c) => c.match(/^oj-avatar-base-[a-z0-9]+/))).true;
  });
});
